import React from "react";
import "./AiAssistantButton.css";

const AIAssistantButton: React.FC = () => {
  return (
    <a
      href="/assistant"
      className="ai-fab"
      aria-label="Open AI assistant"
    >
      {/* Robot (now the anchor for the bubble) */}
      <span className="bot" aria-hidden="true">
        <svg viewBox="0 0 80 80" width="64" height="64" role="img">
          <circle cx="40" cy="8" r="5" fill="#7c7cf0"/>
          <rect x="39" y="13" width="2" height="8" rx="1" fill="#7c7cf0"/>

          <rect x="18" y="20" width="44" height="30" rx="10"
                fill="url(#g1)" stroke="rgba(255,255,255,.25)" />
          <circle cx="34" cy="34" r="3.8" fill="#fff" opacity=".96"/>
          <circle cx="46" cy="34" r="3.8" fill="#fff" opacity=".96"/>
          <rect x="32" y="40" width="16" height="3" rx="1.5" fill="#cfd3ff" opacity=".9"/>

          <rect x="26" y="52" width="28" height="16" rx="8"
                fill="url(#g2)" stroke="rgba(255,255,255,.18)"/>
          <rect x="12" y="30" width="10" height="20" rx="5" fill="url(#g2)" />
          <g className="arm">
            <rect x="58" y="30" width="10" height="20" rx="5" fill="url(#g2)" />
            <circle cx="62.5" cy="27" r="4" fill="#78d2ff" opacity=".95"/>
          </g>

          <defs>
            <linearGradient id="g1" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0" stopColor="#2a2f57"/>
              <stop offset="1" stopColor="#39407b"/>
            </linearGradient>
            <linearGradient id="g2" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0" stopColor="#4d5dff"/>
              <stop offset="1" stopColor="#3347f2"/>
            </linearGradient>
          </defs>
        </svg>

        {/* Bubble is now INSIDE .bot so it hugs the robot */}
        <span className="ai-bubble" aria-hidden="true">I’m your assistant 👋</span>
      </span>

      {/* Label under robot */}
      <span className="label" aria-hidden="true">Start your project</span>
    </a>
  );
};

export default AIAssistantButton;
